exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-cards[data-v-28c8bc34]{margin-bottom:32px}.card-card-name[data-v-28c8bc34]{font-size:.875rem;padding:0 6px;max-width:300px}.card-card-values[data-v-28c8bc34]{display:flex;align-items:center;margin-left:auto;justify-content:flex-end;min-width:125px}.card-card-total[data-v-28c8bc34]{font-weight:600;font-size:.875rem}.card-card-count[data-v-28c8bc34]{font-size:.75rem}", ""]);

// exports
